import { markStripeRedirectStart } from '@/utils/stripeHistoryFix'

export function getAbsoluteHashUrl(hashPathAndQuery) {
  const envBaseUrl = process.env.VUE_APP_FRONTEND_BASE_URL
  if (envBaseUrl) {
    const base = envBaseUrl.replace(/#.*$/, '').replace(/\/+$/, '')
    const path = String(hashPathAndQuery || '').replace(/^[#/]+/, '')
    return `${base}/#/${path}`
  }

  const origin = window.location.origin
  const pathname = (window.location.pathname || '/').replace(/\/index\.html$/i, '/')
  const base = origin + pathname
  const hash = String(hashPathAndQuery || '').startsWith('#') ? String(hashPathAndQuery || '')
    : `#${String(hashPathAndQuery || '')}`
  return `${base}${hash}`
}

export async function startStripeCheckout({ checkoutUrl }) {
  if (!checkoutUrl) {
    throw new Error('Missing Stripe checkout URL')
  }

  markStripeRedirectStart()
  window.location.href = checkoutUrl
}
